export const loaded = handler =>
  document.addEventListener('DOMContentLoaded', handler);
